export default __webpack_public_path__ + "static/media/D_suppliment.daa185e7.jpg";